import React from "react";

import PageComponent from "components/Page";

import SelectClient from "components/SelectClient";
import SelectDateRange from "components/SelectDateRange";
import MultiSelectSearch from "components/MultiSelectSearch";
import Table from "./components/Table";
import TabsSwitch from "components/TabsSwitch";
import Button from "components/Button";
import SelectMultiFilter from "components/SelectMultiFilter";
import ButtonIconSelect from "components/ButtonIconSelect";
import SignDialog from "pages/egisz/components/signDialog";

import { ReactComponent as SignatureTrueIcon } from 'icons/components/signatureTrue.svg';
import { ReactComponent as ArrowRightSIcon } from 'icons/components/arrowRightS.svg';
import { ReactComponent as CloseIcon } from 'icons/components/close.svg';

import './index.less';
import './themes/default.less';

export default class Egisz extends PageComponent {

    constructor(props) {
        super(props);

        this.openIcon = {
            type: "icon",
            typeIcon: "stroke",
            name: "arrow",
            hideLabel: true,
            cantSort: true,
            size: "32px",
            click: this.selectVisit.bind(this)
        };

        this.tableMap = {
            endDate: {
                label: "client.date",
                type: "date",
                format: "DD.MM.YYYY"
            },
            beginDate: {
                label: "main.time",
                type: "date",
                format: "HH:mm"
            },
            doctorId: {
                label: "client.doctor",
                type: "doctor",
                short: true
            },
            client: {
                label: "main.patient",
                type: "client",
                onClick: this.openClient.bind(this),
                style: "hand",
                short: true
            },
            egiszStatus: {
                label: "main.status",
                size: "170px",
                callback: this.statusCell.bind(this),
            },
            doctorSignature: {
                label: "egisz.doctorSignature",
                size: "70px",
                callback: this.signatureFirstCell.bind(this),
            },
            clinicSignature: {
                label: "egisz.clinicSignature",
                size: "70px",
                callback: this.signatureSecondCell.bind(this),
            },
            openIcon: this.openIcon,
        };

        const { dateFrom, dateTo } = this.state.urlProps;

        this.state = {
            ...this.state,
            selectedStartDate: dateFrom ? this._helper.date.fromStr(dateFrom) : this._helper.date.toDateServerStr(this._helper.date.addDays(new Date(), -7)),
            selectedEndDate: dateTo ? this._helper.date.fromStr(dateTo) : !dateTo && !dateFrom ? new Date() : null,
            itemsVisit: [],
            selectVisit: false,
            doctorFilter: [],
            statusFilter: [],
            currentInvoices: [],
            certificates: [],
        };
    }

    componentDidLoad() {
        const dateFrom = this._helper.date.toDateServerStr(this._helper.date.addDays(new Date(), -7));
        const dateTo = this._helper.date.toDateServerStr(new Date());
        this.getVisit(dateFrom, dateTo);
    }

    componentDidUpdate() {
        const { selectedStartDate, selectedEndDate } = this.state;
        if (this.selectDateRange)
            this.selectDateRange.setInputValue({ selectedStartDate, selectedEndDate, type: selectedEndDate ? 1 : 0 });
    }

    get dialogsMap() {
        return {
            "sign": SignDialog,
        };
    }

    onClinicChanged() {
        const dateFrom = this._helper.date.toDateServerStr(this._helper.date.addDays(new Date(), -7));
        const dateTo = this._helper.date.toDateServerStr(new Date());
        this.getVisit(dateFrom, dateTo);
    }

    statusCell(value, map, { medInspections }) {
        const isInspection = medInspections?.length > 0 ? true : false;

        let val = value;
        if (isInspection) {
            if (value === "DIARY_FILLED")
                val = "NO_INVOICE";
            else if (value === "UNFILLED")
                val = "INSPECTION_FILLED";
        }

        return (<div className="statusWrap">
            {this.renderStatus(val)}
        </div>);
    }

    openClient(info) {
        const { id } = info.client;
        this._helper.openClient(id);
    }

    signatureFirstCell(value, map, { egiszStatus }) {
        return (<div className="statusWrap">
            {(egiszStatus === "DOCTOR_APPROVE" || egiszStatus === "DOCTOR_CLINIC_APPROVE") ? <SignatureTrueIcon /> : "-"}
        </div>);
    }

    signatureSecondCell(value, map, { egiszStatus }) {
        return (<div className="statusWrap">
            {(egiszStatus === "DOCTOR_CLINIC_APPROVE") ? <SignatureTrueIcon /> : "-"}
        </div>);
    }

    async selectVisit(info) {
        const { id } = info;
        const selectVisit = id;

        const resp = await this._request.invoices.getInvoiceByVisitId(id);
        const currentInvoices = (resp?.data || []);
        this.setState({ selectVisit, currentInvoices });
    }


    getFormatDate() {
        const { selectedStartDate, selectedEndDate } = this.state;

        const dateFrom = this.dateToServ(selectedStartDate);
        const dateTo = this.dateToServ(selectedEndDate || selectedStartDate);

        return { dateFrom, dateTo };
    }

    async getVisit(dateFrom, dateTo) {
        const { clinicId } = this.state;

        this._helper.showLoading();
        const resp = await this._request.visits.get(clinicId, null, dateFrom, dateTo);
        this._helper.hideLoading();
        let itemsVisit = resp?.data || [];

        itemsVisit = itemsVisit.filter(it => it.client).sort((a, b) => (a.beginDate < b.beginDate) ? -1 : (a.beginDate > b.beginDate) ? 1 : 0);

        itemsVisit = itemsVisit.map((it, i) => {
            it.doctorSignature = /*i % 3 ? true : */false;
            it.clinicSignature = /*i % 6 ? true : */false;
            return it;
        });

        this.setState({ itemsVisit });

    }

    setPageProps({ dateFromN, dateToN }) {
        const { dateFrom, dateTo } = this._helper.getUrlOptions();
        let props = {};
        if (dateFromN || dateFrom)
            props.dateFrom = dateFromN ? dateFromN : dateFrom;
        else
            props.dateFrom = this.dateToServ(new Date());

        if (dateToN && props.dateFrom !== dateToN) {
            props.dateTo = dateToN ? dateToN : dateTo;
        }

        this._helper.setPageProps(props);
    }

    dateToServ(date) {
        return date ? this._helper.date.toDateServerStr(date) : null;
    }

    onForm(selectedRange) {
        const { selectedStartDate, selectedEndDate } = selectedRange;

        const dateFromN = this.dateToServ(selectedStartDate);
        const dateToN = selectedEndDate ? this.dateToServ(selectedEndDate) : null;

        this.setPageProps({ dateFromN, dateToN });
        this.setState({ selectedStartDate, selectedEndDate });
        this.getVisit(dateFromN, dateToN);
    }

    onTabsChange(tab) {
        if (this._helper.getPageTab() === tab)
            return;

        this._helper.setPageTab(tab || this.tabsView.tabKey);
    }

    onCloseFilterItem(id, source) {
        const { doctorFilter, statusFilter } = this.state;
        if (source === "statusFilter")
            this.changeState(source, statusFilter.filter(it => it !== id));
        else
            this.changeState(source, doctorFilter.filter(it => it !== id));
    }

    changeFilter(key, value) {
        this.setState({ [key]: value });
    }

    getInvoiceSum(arr) {
        let sum = 0;
        arr?.forEach(it => {
            sum += it.price * it.count;
        });
        return sum;
    }

    async formDocument(id, patient, snils, sex) {
        const { selectedStartDate, selectedEndDate } = this.state;

        if (snils && sex) {
            this._helper.showLoading();
            const resp = await this._request.egisz.createDocument(id);
            this._helper.hideLoading();
            if (resp?.data) {
                this._helper.showNotify("Документ утвержден", "Документ успешно утвержден для пациента " + patient);
                const answ = await this.updateStatus(id, "PENDING");
                if (answ) {
                    this.openDialog("sign", { id, patient, signQueue: "FIRST" }, this.signDocument.bind(this));
                } else {
                    this.getVisit(selectedStartDate, selectedEndDate);
                }
            }
        } else {
            let text = "Заполните СНИЛС в карте пациента";
            let label = "Не заполнен СНИЛС";
            if (!sex) {
                text = "Заполните пол в карте пациента";
                label = "Не заполнен пол";
            }
            return this._helper.showNotifyPopup({
                type: "error",
                label,
                text,
            });
        }

    }

    async returnApprove(id, patient) {
        const { selectedStartDate, selectedEndDate } = this.state;
        const resp = await this.updateStatus(id, "PENDING");
        if (resp)
            this._helper.showNotify("Сменился статус", "Документ возвращен на утверждение для пациента " + patient);
        this.getVisit(selectedStartDate, selectedEndDate);

    }

    async returnOptimizing(id, patient) {
        const { selectedStartDate, selectedEndDate } = this.state;
        const resp = await this.updateStatus(id, "OPTIMIZING");
        if (resp)
            this._helper.showNotify("Сменился статус", "Документ возвращен на утверждение для пациента " + patient);
        this.getVisit(selectedStartDate, selectedEndDate);
    }

    async signDocument(info, operationId) {
        const { selectedStartDate, selectedEndDate } = this.state;
        const { id, signQueue, patient } = info;

        this._helper.showLoading();
        const resp = await this._request.egisz.signDocument(id, signQueue, operationId);
        this._helper.hideLoading();

        if (resp?.data) {
            this._helper.showNotify("Сменился статус", "Документ подписан для пациента " + patient);
            const status = signQueue === "FIRST" ? "DOCTOR_APPROVE" : "DOCTOR_CLINIC_APPROVE";
            await this.updateStatus(id, status);

            this.getVisit(selectedStartDate, selectedEndDate);
        }
    }

    async updateStatus(id, status) {
        this._helper.showLoading();
        const resp = await this._request.egisz.updateStatus(id, status);
        this._helper.hideLoading();
        return resp?.data;
    }

    renderRow(title, component, bottom) {
        const props = {};

        return (
            <div className="detailRow flex text p1 gap8" {...props}>
                <div className={`rowTitle selectable ${bottom ? "bottom" : ""}`}>{this._helper.string.capitalize(this.tr(title))}</div>
                <div className={`flex1  selectable`}>{component}</div>
            </div>
        );
    }

    renderDiary(medDiaries) {
        const diaryExist = (medDiaries && medDiaries?.length > 0);

        const teethText = this._helper.string.capitalize(this.tr("client.teeth"));

        return (diaryExist ? <div className="flex col gap16">
            {medDiaries.map(diary => (<div>
                <div className="headerTeeth text blockTitle">
                    {`${teethText} ${this._helper.getTeethNames(diary.medDiaryHasTeeth).join(", ")}`}
                </div>
                {diary.medDiaryHasMedSection.filter(it => it.value).map((it, i) => (<div key={"sec" + i} className="flex col gap8">
                    <div className="text p1 black3">{it.title}</div>
                    <div className="text p1">{it.value}</div>
                </div>))}
            </div>))}
        </div> : <div className="text p1 gray3">
            {this.tr("egisz.diaryIsNotFull")}
        </div>);
    }

    renderInspection(medInspections) {
        const medInspection = (medInspections && medInspections?.length > 0) ? medInspections[0] : false;
        //medInspectionHasMedSection
        return (medInspection ? <div className="flex col gap16">
            {medInspection.medInspectionHasMedSection.filter(it => it.value).map((it, i) => (<div key={"sec" + i} className="flex col gap8">
                <div className="text p1 black3">{it.title}</div>
                <div className="text p1">{it.value}</div>
            </div>))}
        </div> : <div className="text p1 gray3">
            {this.tr("price.sectionEmpty")}
        </div>);
    }

    renderRowInvoice(info) {
        return (<div className="flex flex1 rowTabInvoice">
            <div className="cellInvoice flex1">{this._helper.getTeethNames(info.teeth).join(", ")}</div>
            <div className="cellInvoice flex flex1 col">
                <div>{info.title}</div>
                <div className="gray3">{info.altCode}</div>
            </div>
            <div className="cellInvoice flex1">{this._helper.number.toSum(info.price)}</div>
        </div>);
    }

    renderInvoice() {
        const { currentInvoices } = this.state;

        return (currentInvoices.length > 0 ? <div className="flex flex1 col gap16">
            {currentInvoices.map((it, i) => (<div key={`invoice${i}`} className="flex flex1 col gap16">
                <div className="text p1 blue3 hand">
                    {`Счёт ${it.id}/${it.clientId} от ${this._helper.date.toDateStr(it.createdTime)}`}
                </div>
                <div className="tableInvoice">
                    <div className="flex hdTabInvoice text p1 black3">
                        <div className="cellInvoice flex1">Зубы</div>
                        <div className="cellInvoice flex1">Вид работы</div>
                        <div className="cellInvoice flex1">Сумма</div>
                    </div>
                    <div className="flex flex1 col text p1">
                        {it.securedInvoiceItems.map(item => this.renderRowInvoice(item))}
                    </div>
                </div>
                <div className="flex flex1 end">
                    <div className="wrapTotal flex col gap16">
                        <div>{this.renderRow("report.total", this._helper.number.toSum(this.getInvoiceSum(it.securedInvoiceItems)), true)}</div>
                        <div>{this.renderRow("client.discount", `${it.discount} %`, true)}</div>
                        <div>{this.renderRow("treatmentPlan.totalWithDiscount", this._helper.number.toSum(it.totalSum), true)}</div>
                    </div>
                </div>
            </div>))
            }
        </div> : <div className="text p1 gray3">
            Счет не указан
        </div>);
    }

    renderStatus(statusId) {
        const { statusItems } = this._config;
        const item = statusItems.find(it => it.id === statusId);
        const { name, color } = item;
        return (<div className={`status text p1`} style={{ backgroundColor: color }}>
            {this.tr(name)}
        </div>);
    }

    renderRowEvents(info) {
        const { date, text, status1, status2, comment, commentEgisz } = info;

        return (<div className="flex col gap8">
            <div>
                <div className="text p2 gray3">{this._helper.date.toTimeDateStr(date)}</div>
                <div className="text p1">{text}</div>
            </div>
            {comment && <div className="text p1 black2">
                {comment}
            </div>}
            {(status1 && status2) && <div className="flex gap4">
                {status1 && this.renderStatus(status1)}
                {status2 && <div className="flex centerAll"><ArrowRightSIcon /></div>}
                {status2 && this.renderStatus(status2)}
            </div>}
            {commentEgisz && <div className="text p1 black2">
                {commentEgisz}
            </div>}
        </div>);
    }

    renderEvents() {
        /*const events = [
            {
                date: "2024-06-21T08:01:00.000+00:00",
                text: "Дневник успешно принят в ЕГИСЗ",
                status1: "forShipment",
                status2: "accepted",
                comment: "",
                commentEgisz: "",
            },
            {
                date: "2024-06-20T19:25:00.000+00:00",
                text: "Дневник не принят в ЕГИСЗ ",
                status1: "forShipment",
                status2: "notAccepted",
                comment: "",
                commentEgisz: "Здесь будет комментарий от ЕГИСЗ, если он будет. Система перегружена, например?",
            },
            {
                date: "2024-06-20T18:59:00.000+00:00",
                text: "Дневник отправлен в ЕГИСЗ",
                status1: "forShipment",
                status2: "sent",
                comment: "",
                commentEgisz: "",
            },
            {
                date: "2024-06-20T18:59:00.000+00:00",
                text: "Главврач Игнатьева Л. И. утверил и подписал дневник",
                status1: "underReview",
                status2: "forShipment",
                comment: "",
                commentEgisz: "",
            },
            {
                date: "2024-06-20T18:00:00.000+00:00",
                text: "Врач Константинов В. Д. сдал на проверку дневник",
                status1: "finalize",
                status2: "underReview",
                comment: "",
                commentEgisz: "",
            },
            {
                date: "2024-06-20T17:58:00.000+00:00",
                text: "Врач Константинов В. Д. оставил комментарий",
                status1: "",
                status2: "",
                comment: `Слизистая оболочка десны бледная, тусклая, безболезненная, плотная конфигурация дёсневых сосочков`,
                commentEgisz: "",
            },
            {
                date: "2024-06-20T17:03:00.000+00:00",
                text: "Главврач Игнатьева Л. И. отправил на доработку дневник с комментарием",
                status1: "underReview",
                status2: "finalize",
                comment: `На язычной поверхности Флюктуация; Лунка зуба выполнена грануляциями; 
                Усеченность вершин десневых сосочков недостаток места при прорезывании`,
                commentEgisz: "",
            },
            {
                date: "2024-06-20T16:15:00.000+00:00",
                text: "Врач Константинов В. Д. утвердил и подписал дневник",
                status1: "inProgress",
                status2: "underReview",
                comment: "",
                commentEgisz: "",
            },
            {
                date: "2024-06-20T15:45:00.000+00:00",
                text: "Врач Константинов В. Д. взял в работу дневник",
                status1: "notFilledIn",
                status2: "inProgress",
                comment: "",
                commentEgisz: "",
            },
            {
                date: "2024-06-20T09:45:00.000+00:00",
                text: "Врач Константинов В. Д. заполнил дневник к визиту",
                status1: "notFilledIn",
                status2: "filled",
                comment: "",
                commentEgisz: "",
            },
            {
                date: "2024-06-20T09:00:00.000+00:00",
                text: "Врач Константинов В. Д. создал визит без дневника",
                status1: "notFilledIn",
                status2: "",
                comment: "",
                commentEgisz: "",
            },
        ];*/

        const events = [];

        return (<div className="flex col gap16">
            {events.map(it => (<>
                {this.renderRowEvents(it)}
                <div className="popupLine"></div>
            </>))}
        </div>);
    }

    renderRightSide(id) {
        const { itemsVisit } = this.state;
        const info = itemsVisit.find(it => it.id === id);
        if (!info)
            return false;

        const { beginDate, medDiaries, client, doctorId, egiszStatus, medInspections } = info;
        const infoDoctor = globalThis.appPageView.getDoctorById(doctorId);
        const patient = this._helper.string.formatFullName(client, "short");
        const snils = client?.personalData?.SNILS;
        const sex = client?.sex;

        const datetime = this._helper.date.toDateTimeStr(beginDate);

        let buttonText = "Утвердить и подписать";
        if (egiszStatus === "PENDING")
            buttonText = "Подписать";
        else if (egiszStatus === "OPTIMIZING")
            buttonText = "Вернуть на утверждение";
        else if (egiszStatus === "DOCTOR_APPROVE")
            buttonText = "Отправить";

        let handler = null;
        if (egiszStatus === "INVOICE_DIARY_FILLED")
            handler = this.formDocument.bind(this, id, patient, snils, sex);
        else if (egiszStatus === "OPTIMIZING")
            handler = this.returnApprove.bind(this, id, patient);
        else if (egiszStatus === "PENDING")
            handler = this.openDialog.bind(this, "sign", { id, patient, signQueue: "FIRST" }, this.signDocument.bind(this));
        else if (egiszStatus === "DOCTOR_APPROVE")
            handler = this.openDialog.bind(this, "sign", { id, patient, signQueue: "SECOND" }, this.signDocument.bind(this));

        const showButton = (egiszStatus === "INVOICE_DIARY_FILLED" || egiszStatus === "PENDING" || egiszStatus === "DOCTOR_APPROVE" || egiszStatus === "OPTIMIZING");

        const items = [
            { name: "На доработку", onClick: this.returnOptimizing.bind(this, id, patient) },
            { name: "Оставить коментарий", onClick: null },
        ];

        return (<div className="rightSide flex col gap16">
            <div className="flex between">
                <div className="text blockTitle">{datetime}</div>
                <div className="flex gap16">
                    {egiszStatus === "INVOICE_DIARY_FILLED" && <ButtonIconSelect
                        translate={true}
                        stopEvent={true}
                        type="secondary"
                        items={items}
                    />}
                    {showButton && <Button
                        type={"stroke"}
                        size={"small"}
                        label={buttonText}
                        active={false}
                        onClick={handler}
                    />}
                    <CloseIcon
                        className="close hand"
                        style={{ height: "16px", width: "16px" }}
                        onClick={this.changeState.bind(this, "selectVisit", false)} />
                </div>
            </div>
            <div className="flex col gap8">
                {this.renderRow("client.doctor", this._helper.string.formatFullName(infoDoctor, "short"))}
                {this.renderRow("main.patient", patient)}
            </div>
            <TabsSwitch
                ref={el => this.tabsView = el}
                className="flex1 minH0"
                tabs={["client.diary", "client.inspection", "main.invoice", "egisz.events"]}
                pages={[
                    <div className="tabContent flex flex1 minH0 pos rel scrolling all">{this.renderDiary(medDiaries)}</div>,
                    <div className="tabContent flex flex1 minH0 pos rel scrolling all">{this.renderInspection(medInspections)}</div>,
                    <div className="tabContent flex flex1 minH0 pos rel scrolling all">{this.renderInvoice()}</div>,
                    <div className="tabContent flex flex1 minH0 pos rel scrolling all">{this.renderEvents()}</div>,
                ]}
            />

        </div>);
    }

    renderFilterItem(labelValue, key, id, source) {
        return (<div key={key} className="filterCell flex gap8">
            <div className="text p1 black2">{labelValue}</div>
            <div className="flex centerV hand" style={{ width: "15px" }} onClick={this.onCloseFilterItem.bind(this, id, source)} >
                <CloseIcon className="closeIcon" />
            </div>
        </div>);
    }

    renderDoctorFilter(arr, doctors) {
        return (<div className="flex gap8">
            {arr.map((id, i) => {
                const item = doctors.find(it => it.id === id);
                return this.renderFilterItem(item.name, i, id, "doctorFilter");
            })}
        </div>);
    }

    renderStatusFilter(arr, statusItems) {
        return (<div className="flex gap8">
            {arr.map((id, i) => {
                const item = statusItems.find(it => it.id === id);
                return this.renderFilterItem(this.tr(item.name), i, id, "statusFilter");
            })}
        </div>);
    }

    renderPage() {
        const { itemsVisit, doctorFilter, statusFilter, selectVisit } = this.state;
        const doctors = this._helper.getDoctors().filter(it => it.shortName).map(it => {
            const { id, shortName } = it;
            return { id, name: shortName };
        });

        const { statusItems } = this._config;

        const items = (doctorFilter.length > 0 || statusFilter.length > 0) ? itemsVisit.filter(it => {
            let show = true;
            if (doctorFilter.length > 0 && !doctorFilter.includes(it.doctorId))
                show = false;
            if (statusFilter.length > 0 && !statusFilter.includes(it.egiszStatus))
                show = false;
            return show;
        }) : itemsVisit;

        return (
            <div className="flex col gap16 w100" >
                <div className="flex between w100">
                    <div className="text pageTitle">{this.tr("menu.egisz")}</div>
                    <div>
                        <SelectClient
                            className={"bodySelClientDef"}
                            searchShow={true}
                            onClick={null}
                        />
                    </div>
                </div>
                <div className="wrapMain flex flex1 minH0 ">
                    <div className="leftSide flex col w100 gap16">
                        <div className="filtreBlock flex gap8 endV">
                            <SelectDateRange ref={el => this.selectDateRange = el} onForm={this.onForm.bind(this)} />
                            <MultiSelectSearch
                                selected={doctorFilter}
                                items={doctors}
                                fixedHolder={""}
                                onChange={this.changeFilter.bind(this, "doctorFilter")}
                            />
                            <SelectMultiFilter
                                selected={statusFilter}
                                items={statusItems}
                                fixedHolder={this.tr("employee.status")}
                                onChange={this.changeFilter.bind(this, "statusFilter")}
                            />
                        </div>
                        {doctorFilter.length > 0 && this.renderDoctorFilter(doctorFilter, doctors)}
                        {statusFilter.length > 0 && this.renderStatusFilter(statusFilter, statusItems)}
                        <div className="tableItem flex rad8 flex1 minH0 pos rel scrolling all">
                            <Table
                                tableMap={this.tableMap}
                                items={items}
                            />
                        </div>
                    </div>
                    {selectVisit && this.renderRightSide(selectVisit)}
                </div>
            </div>
        );
    }
}
